import React, {useState, useEffect} from 'react';
import {FazendaObject} from "models/Fazenda";
import {getFormDefFazenda} from "./controller";
import FieldView from "components/FieldView";
import {IonIcon, IonProgressBar, IonSkeletonText} from "@ionic/react";
import {star} from "ionicons/icons";
import EntityView from "components/EntityView";
import fb from "lib/firebase";
import {actions} from "lib/app";
import {useAppDispatch} from "lib/hooks";
import {dataInCurrentMonth} from "../../lib/utils";
import {useGetProprietario} from "../../lib/DataHooks/proprietarios";
import FormFazenda from "./FormFazenda/FormFazenda";

interface AbaFazendaProps {
  instance: FazendaObject;
  goBack: () => void;
  loading: boolean;
}

const formDef = getFormDefFazenda();

const AbaFazenda: React.FC<AbaFazendaProps> = (props) => {
  const {instance, loading, goBack} = props;
  const dispatch = useAppDispatch();
  const [allowDelete, setAllowDelete] = useState(false);

  const [proprietario, propIsLoadind, propNotFound] = useGetProprietario(instance._proprietario.id);

  useEffect(() => {
    setAllowDelete(dataInCurrentMonth(instance.criado_em.toDate()));
  }, [instance.criado_em]);

  const onDelete = () => {
    fb.db.collection('fazendas').doc(instance.id).delete()
      .then(() => {
        dispatch(actions.notifySuccess('Fazenda excluída com sucesso.'));
        goBack();
      });
  };

  return (
    <>
      {loading &&
        <IonProgressBar type="indeterminate"/>
      }
      {!loading &&
        <EntityView
          instance={instance}
          ModelForm={FormFazenda}
          entityLabel="Fazenda"
          gender="f"
          onDelete={onDelete}
          allowDelete={allowDelete}
          modalNoPadding={true}
        >
          <FieldView def={formDef.designacao} value={instance.designacao}/>
          <FieldView
            def={formDef.nome}
            value={
              <div className="flex">
                <div className="flex-grow">
                  {instance.nome}
                </div>
                <IonIcon
                  icon={star}
                  className={`ml-4 text-4xl ${instance.matriz ? "text-yellow-400" : "text-gray-300"}`}
                  style={{minWidth: '42px', width: '42px'}}
                />
              </div>
            }
            className="text-2xl"
          />

          <FieldView def={formDef.responsavel} value={instance.responsavel}/>

          <FieldView
            label={'Proprietário'}
            value={
              <>
                {propIsLoadind && <IonSkeletonText animated style={{width: 120}}/>}
                {propNotFound && <span className="text-red-500">Não encontrado</span>}
                {proprietario && <span>{proprietario.nome} - {proprietario.telefone}</span>}
              </>
            }
          />


          {instance.gerente &&
            <FieldView def={formDef.gerente} value={instance.gerente}/>
          }

          <FieldView def={formDef.tipo} value={instance.tipo}/>

          {
            instance.veterinario.length > 0 &&
            <FieldView label="Veterinário(s)"
                       value={instance.veterinario.map(i => i.label).join(', ')}/>
          }

          <div className="flex flex-wrap">
            <div className="w-8/12">
              <FieldView def={formDef.cidade} value={instance.cidade}/>
            </div>
            <div className="w-4/12">
              <FieldView def={formDef.estado} value={instance.estado}/>
            </div>
          </div>

          <FieldView def={formDef.telefone} value={instance.telefone}/>

          <FieldView def={formDef.email} value={instance.email}/>

          <div className="app-modelview-section-title">
            Localização
          </div>

          <div className="flex">
            <div className="w-1/2">
              <FieldView def={formDef.latitude} value={instance.latitude}/>
            </div>
            <div className="w-1/2">
              <FieldView def={formDef.longitude} value={instance.longitude}/>
            </div>
          </div>

          <div className="app-modelview-section-title">
            Informações adicionais
          </div>

          <FieldView def={formDef.tem_calendario_sanitario}
                     value={instance.tem_calendario_sanitario}/>

          {
            instance.tipo.indexOf('Corte') !== -1 &&
            <>
              <FieldView def={formDef.sistema_producao}
                         value={instance.sistema_producao}/>
              <FieldView def={formDef.possui_estacao_monta}
                         value={instance.possui_estacao_monta}/>
            </>
          }
          {
            instance.tipo.indexOf('Leite') !== -1 &&
            <>
              <FieldView def={formDef.sistema_producao_leite}
                         value={instance.sistema_producao_leite}/>
              <FieldView label="Produção litros/dia" type="number"
                         value={instance.producao_litros_dia}/>
            </>
          }

          <FieldView label="Quantidade de animais" type="number"
                     value={instance.quantidade_animais}/>
        </EntityView>
      }
    </>
  );
}

export default AbaFazenda;
